<script lang="ts" setup>
import { entityProp } from '../components/ToccoAccordion.vue'

defineProps<{
  entity: entityProp
}>()
</script>

<template>
  <Section>
    <div class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1">
      <ToccoAccordion :entity="entity" />
    </div>
  </Section>
</template>

<style lang="scss" scoped></style>
